import { createImmerReducer } from '@reducers/utils/createReducer';

const initialState = {};

export default createImmerReducer(initialState, {});
